import { createGlobalStyle } from 'styled-components'

import '@coreui/coreui/dist/css/coreui.min.css'
//00AF30
const GlobalStyle = createGlobalStyle`
    :root {
        --color-sidebar: #04110A;
        --color-sidebar-hover: #0075BA;
        --color-background: #f8f8f8;
        --color-background-card: #ffffff;
        --color-background-title-bar: #f8f8f8;
        --color-background-footer: #f8f8f8;
        --color-background-input: #f2fafd;
        --color-background-report-card: #f2fafd;
        --color-font: #04110A;
        --color-icons: #04110A;
        --color-white: #fcfafa;
        --color-grey: #d3cede;
        --color-blue: #0180c3;
        --color-green: #04110A;
        --color-orange: #E35A26;
        --color-red: #F55859;
        --color-yellow: #0075BA;
        --color-fff: #fff;
        --color-000: #fff;
    }
    * {
        box-sizing: border-box;
    }
    body {
        font-family: Arial, Helvetica, sans-serif;
        margin: 0;
		padding: 0;
        background-color: var(--color-background);
        color: var(--color-font);
        max-width: 100vw;
        overflow-x: hidden;
    }
    h1, h2, h3, h4, h5, h6, p {
        margin: 0;
    }

    .swal2-styled.swal2-confirm {
        background-color: var(--color-yellow);
    }
`
export default GlobalStyle